import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FadeUp } from "./anim";

const FAQS = [
  {
    q: "Does the Solar Garden really produce usable electricity?",
    a: "Yes. Two 440W solar panels feed a microinverter that outputs up to 900W of AC power — the same kind of power your home already uses. When installed and connected per applicable electrical and utility requirements, that production can offset a portion of the electricity you'd otherwise buy from the grid.",
  },
  {
    q: "Do I need space on my roof?",
    a: "No. The Solar Garden is a freestanding outdoor feature. It's ideal for homeowners who want solar generation without covering their roof in panels, or who have limited usable roof space.",
  },
  {
    q: "How much will it actually save me?",
    a: "It depends on your location, electric rate, shading, and how much of the solar energy you use directly in your home. Use the savings estimator above for a quick projection — we'll confirm real numbers for your address when you request a quote.",
  },
  {
    q: "Where can I put it?",
    a: "Patios, backyards, poolside, or as part of an outdoor living area. Its compact footprint is designed to look like it belongs there — one space, two harvests.",
  },
  {
    q: "What about permitting and installation?",
    a: "The Solar Garden is a cord-and-plug connected solar PV system — no permanent hardwiring required. It plugs into a standard outlet, so setup is simple. We recommend confirming any local requirements for plug-in solar in your area.",
  },
  {
    q: "What does it cost?",
    a: "Each Solar Garden is made to order, so pricing is determined on a project-by-project basis based on scope and materials. Request a quote and we'll put together a tailored figure for your space.",
  },
];

export const FAQ = () => {
  return (
    <section
      id="faq"
      className="relative bg-sg-bg py-24 sm:py-32 border-t border-sg-border/50"
      data-testid="faq-section"
    >
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="grid gap-10 lg:grid-cols-12">
          <FadeUp className="lg:col-span-4">
            <span className="text-xs uppercase tracking-[0.25em] text-sg-primary">
              Good questions
            </span>
            <h2 className="mt-5 font-display text-4xl sm:text-5xl tracking-tight text-sg-fg">
              Before you grow.
            </h2>
            <p className="mt-5 text-base text-sg-muted font-light max-w-sm">
              Everything you'd want to know about how the Solar Garden works —
              and what it can do for your home.
            </p>
          </FadeUp>

          <FadeUp className="lg:col-span-8" delay={0.1}>
            <Accordion type="single" collapsible className="w-full">
              {FAQS.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  className="border-b border-sg-border"
                  data-testid={`faq-item-${i}`}
                >
                  <AccordionTrigger className="text-left font-display text-lg sm:text-xl text-sg-fg hover:text-sg-primary hover:no-underline py-6">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-sm text-sg-muted font-light leading-relaxed pb-6 max-w-2xl">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </FadeUp>
        </div>
      </div>
    </section>
  );
};
